@import (reference) '../../../../constants/spacing.module.less';

.enhanced-return-details-layout-column {
  display: flex;
  flex-flow: column nowrap;
  row-gap: @space-16;
  overflow-wrap: anywhere;
}

.address-column {
  .enhanced-return-details-layout-column();
  grid-area: address-column;
}

.rma-column {
  .enhanced-return-details-layout-column();
  grid-area: rma-column;
}

.cost-summary-column {
  .enhanced-return-details-layout-column();
  grid-area: cost-summary-column;
  padding-left: @space-16;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: @space-24;
    width: 1px;
    background-color: var(--grey-300);
  }
}

@container (max-width: 700px) {
  .cost-summary-column {
    padding: 0;

    &::before {
      display: none;
    }
  }
}
